import { co2 } from './common';

export default {
  'consumption.co2': `Emissões ${co2} Combinadas`,
  'consumption.energy': 'Consumo de energia elétrica combinado',
  'consumption.fuel': 'Consumo de combustível combinado',
  'footnotes.local': '',
  'footnotes.wltp': `Os valores indicados foram determinados de acordo com o método da medição prescrito. São os "valores de ${co2} de WLTP", nos termos do artigo 2, n.º3, do Regulamento de Execução(EU) 2017/1153. Os números/valores não se referem a um veículo individualmente e não são parte da proposta; são fornecidos unicamente com o objetivo de ajudar na comparação entre diferentes modelos de veículos automóveis. Estes valores variam consoante os extras opcionais escolhidos.O consumo de energia e a autonomia foram calculados com base no Regulamento 692/2008/CE.O consumo de energia e a autonomia dependem da configuração do veículo.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': `Para mais informação sobre dados oficiais de consumo e emissões de ${co2} de automóveis ligeiros de passageiros, por favor contacte o seu Concessionário Oficial Mercedes-Benz.`,
  'search.input.label': 'Termo de pesquisa / Configurador código online',
  'search.result.buy-online': 'Comprar online',
  'search.results': 'Sem resultados. | {count} Resultado de pesquisa | {count} Resultados de pesquisa',
  'search.results.count': ' {count} Resultados de pesquisa',
  'search.results.backup': 'Não foram encontrados dados semelhantes. Ver páginas semelhantes:',
  'search.results.none.summary':
    'Não existem resultados de pesquisa relacionados com este termos. Por favor tente novamente com um termo diferente.',
  'search.show-more': 'Mostrar mais',
  'search.unavailable': 'A pesquisa não está disponível.',
  'search.result.new': 'Novo',

  'input.placeholder': 'Termo de pesquisa / Configurador código online',

  'suggestions.all_search_results': 'Todos os resultados da pesquisa',
  'suggestions.all_search_results_for': 'Mostrar todos os resultados de',
  'suggestions.in': 'em',

  all: 'Todos',
  UCOS: 'Online Store de veículos usados',
  PASSENGER_CARS: 'Veículos ligeiros de passageiros',
  VANS: 'Furgões',
  NCOS: 'Online Store de veículos novos',
  VIDEO: 'Vídeos',
  DEALER_LOCATOR: 'Pesquisa de concessionários',
  CONFIGURATOR: 'Configurador',
  TEST_DRIVE: 'Prova de estrada',
  VEHICLE_SEARCH: 'Pesquisa de veículos usados',
  COLLECT: 'Collection e acessórios',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Acessórios de carro',

  'search.result.consumption': 'Consumo',
  'watch.video': 'Ver o vídeo',
  'input.recently': 'Pesquisas recentes',
  'input.help.title': 'O que deve procurar?',
  'input.help.text':
    'Pesquise através dos tipos de veículos, modelos, códigos de configuração ou por acessórios, outros produtos e informações',

  // No results
  'support.check': 'Verifique se há erros de escrita ou tente novamente com um termo diferente.',
  'support.no.results': 'Não há resultados de pesquisa disponíveis para este termo de pesquisa.',
  'support.no.results.term': 'Nenhum resultado encontrado',
  'support.chat': 'Não consegue encontrar o que procura? Por favor, use o nosso',
  'support.chat.with.us': 'Suporte Online-Chat',

  'search.results.offer': 'Ofertas populares para "{query}":',
};
